import { useContext } from 'react';
import { shallowEqual } from 'react-redux';

import { FormField } from '@zillow/constellation-10';
import { useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get } from '@zg-rentals/rental-manager-env';

import { ModularListingContext } from '../../../../containers/CreateListingPage/context';

import { useSelector } from '../../../../selectors/useSelector';

import accessUtils from '../../../../utils/accessUtils';

import { DISPLAY_SERVER_ERROR_AT } from '../../../../constants/WizardConstants';

import WizardAlert from '../../../WizardAlert';
import SFCostAndFeesTotalMonthlyPriceWithFeeAlert from '../../../Alerts/SFCostAndFeesTotalMonthlyPriceWithFeeAlert';
import SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert from '../../../Alerts/SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert';

import CostsAndFeesFormField from './CostsAndFeesFormField';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

const FormSectionContainer = () => {
  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const {
    appConfigCanAccessTotalMonthlyPriceWithFee,
    cookieEnabledServices,
    isOptInTotalMonthlyPriceWithFeeEligible,
    isTotalMonthlyPriceWithFeeEligible,
    listingAlias,
  } = useSelector((state) => {
    return {
      appConfigCanAccessTotalMonthlyPriceWithFee: state.app.appConfig.config.features.canAccessTotalMonthlyPriceWithFee,
      cookieEnabledServices: state.app.cookieEnabledServices,
      isOptInTotalMonthlyPriceWithFeeEligible:
        state.properties.currentProperty?.totalMonthlyPriceWithFee.isOptInEligible,
      isTotalMonthlyPriceWithFeeEligible: state.properties.currentProperty?.totalMonthlyPriceWithFeeNotice?.isEligible,
      listingAlias: state?.properties?.currentProperty?.listingAlias,
    };
  }, shallowEqual);

  const { data } = useRentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get({
    listingAlias,
  });

  const canAccessTotalMonthlyPriceWithFee = accessUtils.canAccessTotalMonthlyPriceWithFee({
    cookieEnabledServices,
    canAccessTotalMonthlyPriceWithFee: appConfigCanAccessTotalMonthlyPriceWithFee,
    isEligible: isTotalMonthlyPriceWithFeeEligible,
  });

  if (!data) {
    return null;
  }

  return (
    <div data-testid="FormSectionContainer">
      <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />

      <WizardFormSectionContainer>
        <WizardHeading level={1} textStyle="heading-sm">
          What additional costs and fees do you charge?
        </WizardHeading>

        <WizardBody>
          {isOptInTotalMonthlyPriceWithFeeEligible ? (
            <>
              These details help renters know the real cost of renting your property, and helps you meet relevant fee
              transparency laws.{' '}
            </>
          ) : (
            <>
              We&apos;ve highlighted some of the most common fee{' '}
              {canAccessTotalMonthlyPriceWithFee ? 'types' : 'categories'}. These details help renters know the real
              cost of renting your property before they apply.
            </>
          )}
        </WizardBody>

        {canAccessTotalMonthlyPriceWithFee && <SFCostAndFeesTotalMonthlyPriceWithFeeAlert />}
        {isOptInTotalMonthlyPriceWithFeeEligible && <SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert />}

        <FormField>
          <CostsAndFeesFormField displayedLocation="posting_path" />
        </FormField>
      </WizardFormSectionContainer>
    </div>
  );
};

export default FormSectionContainer;
